/** The `main` landmark's id: the skip link targets it and route changes focus it. */
export const MAIN_ID = 'main';
